import React from 'react';
import { OptionLayoutsSkeleton } from '../Skeleton/OptionLayouts.Skeleton';
import { OptionSizesSkeleton } from '../Skeleton/OptionSizes.Skeleton';
import { AddButtonWrapperSkeleton } from '../Skeleton/AddButtonWrapper.Skeleton';
import { MEDIA_BREAKPOINTS } from '../../../../../constants/MEDIA_BREAKPOINTS';
export const CustomWallDisplayFormSkeleton = () => (React.createElement("div", null,
    React.createElement(OptionLayoutsSkeleton, { nbItems: 9, showItemLabel: false }),
    React.createElement(OptionSizesSkeleton, null),
    MEDIA_BREAKPOINTS.LG_UP.matches &&
        React.createElement(AddButtonWrapperSkeleton, null)));
